import { AddMemberWizard } from '@/features/members';

export default function TeamAddRoute() {
  return <AddMemberWizard />;
}
